import { SigningActivityOutcome } from '../../../../../../extViewmodels/sdk/models';

export function getSigningActivityTitle(outcome?: SigningActivityOutcome): string {
	switch (outcome) {
		case 'Sent':
			return 'Sent for signature';
		case 'Declined':
			return 'Declined to sign';
		case 'Voided':
			return 'Signature request cancelled';
		case 'Expired':
			return 'Signature request expired';
		default:
			return 'Signature request';
	}
}

export function getSigningActivityDetail(outcome?: SigningActivityOutcome, reason?: string): string | undefined {
	if (!reason?.trim()) {
		return undefined;
	}

	return outcome === 'Declined' || outcome === 'Voided' ? reason.trim() : undefined;
}
